"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _ApplicationContext = require("../../../api/ApplicationContext");
var _SecurityContextHolder = require("../../../api/SecurityContextHolder");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class MultiSiteDropDown extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
  }
  componentDidMount() {
    const context = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
    if (context != null) {
      this.setState({
        subSiteId: context.subSiteId
      });
    }
  }
  onChange(event) {
    const context = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
    context.subSiteId = event.target.value;
    _SecurityContextHolder.SecurityContextHolder.setCurrentContext(context);
    const menuItem = context.getSelectedSubSite();
    this.setState({});
    this.props.history.push(menuItem.path);
  }
  render() {
    if (!_ApplicationContext.ApplicationContext.isMultiSite() || !_SecurityContextHolder.SecurityContextHolder.isAuthenticated() || !_SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
    }
    const context = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
    const {
      subSiteId
    } = context;
    const {
      className
    } = this.props;
    const topMenus = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu.getChildren('Main-Menu-Links');
    if (topMenus) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ml-4 mr-4 as"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "control is-expanded ml-6 mr-6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: `select is-warning mt-2 mr-4 ${className}`
      }, /*#__PURE__*/_react.default.createElement("select", {
        id: "subsite",
        value: subSiteId,
        onChange: this.onChange
      }, typeof topMenus !== 'undefined' && topMenus.filter(site => typeof site.visible !== 'undefined' && site.visible).map(site => /*#__PURE__*/_react.default.createElement("option", {
        value: site.id,
        key: `multisite_dd_${site.id}`
      }, site.name))))));
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  }
}
MultiSiteDropDown.propTypes = {
  className: _propTypes.default.string,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    children: _propTypes.default.array,
    description: _propTypes.default.string,
    icon: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    image: _propTypes.default.string,
    imageAlt: _propTypes.default.string,
    path: _propTypes.default.string,
    title: _propTypes.default.string,
    visible: _propTypes.default.bool,
    className: _propTypes.default.string
  })),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    goBack: _propTypes.default.func.isRequired,
    listen: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string.isRequired
    })
  })
};
MultiSiteDropDown.defaultProps = {
  menuItems: [],
  className: ''
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(MultiSiteDropDown);
//# sourceMappingURL=MultiSiteDropDown.js.map